<script setup lang="ts">
import type { MonospaceWorkspace } from '#layers/data-model/public';
import type { LogoSize } from '#layers/ui/public';
import { BrandLogo } from '#layers/assets/public';

export interface WorkspaceLogoProps {
	workspace: MonospaceWorkspace;
	size?: LogoSize;
	class?: string;
}

const props = defineProps<WorkspaceLogoProps>();
</script>

<template>
	<BrandLogo :logo-id="props.workspace.logoId" :color="props.workspace.primaryColor" :size="props.size" :class="props.class" />
</template>
